import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NoteRegular from './note-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NoteRegular {...validProps} />;
}
SvgComponent.iconName = 'noteRegular';

export const NoteRegularIcon = svgIconWrapper(SvgComponent);
